//import { getEntidadePorCnpj, getTodasEntidades } from "../../services/apiCad";
// import { keycloakService } from "./keycloakService";
import keycloak from "../../keycloak";
import type { IEfpc } from "../Interfaces";

export type Papel =
    | 'DILIC_MASTER'
    | 'DILIC_USUARIO'
    | 'DICOL_CGDC'
    | 'DIFIS_CGRE'
    | 'PREVIC_CONSULTAR'
    | 'ENTIDADE_ALTERAR'
    | 'ENTIDADE_CONSULTAR';

export const Papel = {
    DILIC_MASTER: 'DILIC_MASTER',
    DILIC_USUARIO: 'DILIC_USUARIO',
    DICOL_CGDC: 'DICOL_CGDC',
    DIFIS_CGRE: 'DIFIS_CGRE',
    PREVIC_CONSULTAR: 'PREVIC_CONSULTAR',
    ENTIDADE_ALTERAR: 'ENTIDADE_ALTERAR',
    ENTIDADE_CONSULTAR: 'ENTIDADE_CONSULTAR',
} as const;

const CNPJ_PREVIC = '07290290000102';
const STORED_USERDATA = 'STORED_USERDATA';

interface UserData {
    username: string;
    papel: Papel;
    entidades: IEfpc[];
}

function decodeJWT(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
}

export const carregarDadosUsuario = async (): Promise<UserData | undefined> => {
    const ud = sessionStorage.getItem(STORED_USERDATA);
    if (ud) {
        //Já tem dados
        return JSON.parse(ud);
    }

    if (!keycloak.token) {
        //erro
        return undefined;
    }


    const claims = decodeJWT(keycloak.token);
    const username = claims['preferred_username'];
    const grupos: string[] = claims['resource_access'][import.meta.env.VITE_APP_KEYCLOAK_CLIENTID_ROLES]['roles'];
    // grupos.push(claims['roles']);

    let papel = undefined;
    let entidades: IEfpc[] = [];
    if (grupos.length === 0) {
        //erro
        return undefined;
    }

    if (grupos.length === 1 && grupos[0].substring(0, 14) === CNPJ_PREVIC) {
        if (grupos[0].endsWith(".cnpj-n1")) {
            papel = Papel.PREVIC_CONSULTAR;
        }
        else if (grupos[0].endsWith(".cnpj-n2")) {
            papel = Papel.DICOL_CGDC;
        }
        else if (grupos[0].endsWith(".cnpj-n3")) {
            papel = Papel.DIFIS_CGRE;
        }
        else if (grupos[0].endsWith(".cnpj-n4")) {
            papel = Papel.DILIC_USUARIO;
        }
        else if (grupos[0].endsWith(".cnpj-n5")) {
            papel = Papel.DILIC_MASTER;
        }
        // entidades = await getTodasEntidades();
    }
    else {
        for (const grupo of grupos) {
            if (papel && grupo.endsWith(".cnpj-n1")) {
                papel = Papel.ENTIDADE_CONSULTAR;
            }
            else if (grupo.endsWith(".cnpj-n2")) {
                papel = Papel.ENTIDADE_ALTERAR;
            }
            // if (papel) {
            //     const entidade = await getEntidadePorCnpj(grupo.substring(0, 14));
            //     entidades.concat(entidade);
            // }
        }
    }
    if (!papel) {
        //erro
        return undefined;
    }

    const userdata: UserData = {
        username: username,
        papel: papel,
        entidades: entidades
    }
    sessionStorage.setItem(STORED_USERDATA, JSON.stringify(userdata));

    return userdata;
}
export const limparLogado = () => {
    sessionStorage.removeItem(STORED_USERDATA);
}

const getUserData = (): UserData | undefined => {
    const ud = sessionStorage.getItem(STORED_USERDATA);
    if (!ud)
        return undefined;
    return JSON.parse(ud)
}
export const getUser = (): string => {
    return getUserData()?.username || "";
};
export const getPapel = (): Papel | undefined => {
    return getUserData()?.papel;
};
export const getEntidadesDoUsuario = (): IEfpc[] => {
    return getUserData()?.entidades || [];
};

export const hasPermissao = (permissoes: Papel[]): boolean => {
    const papel = getPapel();
    if (!papel) return false;
    return permissoes.includes(papel);
};

export const hasAnyPermissao = (): boolean => {
    const papel = getPapel();
    if (!papel)
        return false;
    else
        return true;
};

export const isEntidadeS3ouS4 = () => {
    const papel = getPapel();
    if (papel === Papel.ENTIDADE_ALTERAR) {
        for (let ent of getEntidadesDoUsuario()) {
            if (ent.codigoEnquadramento && [3, 4].includes(ent.codigoEnquadramento)) {
                return true;
            }
        }
    }
    return false;
};

